module.exports = __webpack_public_path__ + "img/solveCount.e03beb42.png";